Date.locale = {
    en: {
        month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    no: {
        month_names: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"]
    }
};
Date.prototype.getMonthName = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'no';
    return Date.locale[lang].month_names[this.getMonth()];
};

const mixin = {
    methods: {
        formatDate(dtStr, showTime, lang){
            if(!dtStr) return ''
            var monthNames = [

            ];

            var dt = new Date(dtStr.replace(/-/g, "/"))

            var time = ''
            if(showTime)
                time = ' ' + dt.getHours().toString().replace( /^([0-9])$/, '0$1' ) + ':' + dt.getMinutes().toString().replace( /^([0-9])$/, '0$1' )
            return dt.getDate() + '. ' + dt.getMonthName(lang) + ' ' + dt.getFullYear() + time
        },
        getStateColor(state, nullAsZero){

            if(nullAsZero && !state) return 'red'
            //console.log(state)
            let st = parseInt(state);
            if(st > 0){
                return 'green';
            }else if(st == 0){
                return 'yellow';
            }else if(st < 0){
                return 'red'
            }else{
                return 'white'
            }
        },
        getSentColor(status, sent_at){
            
            if(status == 3){
                return 'red-status';
            }
            else if(status == 2){
                return 'blue-status';
            }
            else if(status == 1){
                return 'green-status';
            }
            else if(sent_at){
                return 'green-status';
            }
            else {
	            return 'white-status'
            }
        }
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/utils.js